import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let SBProBorder = class SBProBorder extends Vue {
};
__decorate([
    Prop()
], SBProBorder.prototype, "borderType", void 0);
__decorate([
    Prop()
], SBProBorder.prototype, "borderClasses", void 0);
SBProBorder = __decorate([
    Component({})
], SBProBorder);
export default SBProBorder;
